import { CommonModels } from "@/data/common/common.models";
import { AppRestClient } from "@/util/rest/clients/app-rest-client";

import { BizUserModels } from "./bizUser.models";

export namespace BizUserApi {
  export const getCurrentUserInfo = () => {
    return AppRestClient.get({ resSchema: BizUserModels.GetCurrentUserInfoResponseDtoSchema }, `/biz/user/me`);
  };

  export const updateCurrentUserInfo = (data: BizUserModels.UpdateBizUserDto) => {
    return AppRestClient.patch({ resSchema: CommonModels.BizUserDtoSchema }, `/biz/user/me`, data);
  };

  export const requestUploadProfilePicture = (data: CommonModels.MediaUploadFileRequest) => {
    return AppRestClient.post(
      { resSchema: CommonModels.MediaUploadInstructionsSchema },
      `/biz/user/me/profile-picture/request-upload`,
      data,
    );
  };
}
